import { isWatchedEntry } from '@/utils/memberEntryHubBranches';

const MEMBER_ENTRY_SEEN_CAP = 500;
const LAST_SEEN_STORAGE_KEY = 'memberEntryLastSeenAt';

const loadLastSeen = () => {
  try {
    return window.localStorage.getItem(LAST_SEEN_STORAGE_KEY) || null;
  } catch (e) {
    return null;
  }
};

const persistLastSeen = (value) => {
  try {
    if (value) {
      window.localStorage.setItem(LAST_SEEN_STORAGE_KEY, value);
    } else {
      window.localStorage.removeItem(LAST_SEEN_STORAGE_KEY);
    }
  } catch (e) { /* ignore */ }
};

export default {
  state: {
    showDocumentsMembersPopupGeneral: false,
    documentMembersPopupRecordIdGeneral: undefined,

    showNotesMembersPopupGeneral: false,
    notesPopupMembersRecordIdGeneral: undefined,

    showActivityMembersPopupGeneral: false,
    activityPopupMembersRecordIdGeneral: undefined,

    showTasksMembersPopupGeneral: false,
    tasksPopupMembersRecordIdGeneral: undefined,

    showEntriesMemberPopupGeneral: false,
    entrieMemberRecordIdGeneral: undefined,
    entrieMemberObjectGeneral: undefined,

    memberEntryQueue: [],
    memberEntrySeenIds: [],
    memberEntryLastSeenAt: loadLastSeen(),
  },

  mutations: {
    showDocumentsMembersPopupFunc(state, payload) {
      state.showDocumentsMembersPopupGeneral = true;
      state.documentMembersPopupRecordIdGeneral = payload;
    },
    closeDocumentsMembersPopupFunc(state) {
      state.showDocumentsMembersPopupGeneral = false;
      state.documentMembersPopupRecordIdGeneral = undefined;
    },

    showNotesMembersPopupFunc(state, payload) {
      state.showNotesMembersPopupGeneral = true;
      state.notesPopupMembersRecordIdGeneral = payload;
    },
    closeNotesMembersPopupFunc(state) {
      state.showNotesMembersPopupGeneral = false;
      state.notesPopupMembersRecordIdGeneral = undefined;
    },

    showActivityMembersPopupFunc(state, payload) {
      state.showActivityMembersPopupGeneral = true;
      state.activityPopupMembersRecordIdGeneral = payload;
    },
    closeActivityMembersPopupFunc(state) {
      state.showActivityMembersPopupGeneral = false;
      state.activityPopupMembersRecordIdGeneral = undefined;
    },

    showTasksMembersPopupGeneralFunc(state, payload) {
      state.showTasksMembersPopupGeneral = true;
      state.tasksPopupMembersRecordIdGeneral = payload;
    },
    closeTasksMembersPopupGeneralFunc(state) {
      state.showTasksMembersPopupGeneral = false;
      state.tasksPopupMembersRecordIdGeneral = undefined;
    },

    showEntriesMembersPopupGeneralFunc(state, payload) {
      state.showEntriesMemberPopupGeneral = true;
      state.entrieMemberRecordIdGeneral = payload.id;
      state.entrieMemberObjectGeneral = payload;
    },
    closeEntriesMembersPopupGeneralFunc(state) {
      state.showEntriesMemberPopupGeneral = false;
      state.entrieMemberRecordIdGeneral = undefined;
      state.entrieMemberObjectGeneral = undefined;
    },

    enqueueMemberEntry(state, payload) {
      if (!payload || !payload.entryLogId) {
        return;
      }
      if (state.memberEntrySeenIds.includes(payload.entryLogId)) {
        return;
      }

      state.memberEntryQueue.push(payload);
      state.memberEntrySeenIds.push(payload.entryLogId);
      if (state.memberEntrySeenIds.length > MEMBER_ENTRY_SEEN_CAP) {
        state.memberEntrySeenIds.splice(0, state.memberEntrySeenIds.length - MEMBER_ENTRY_SEEN_CAP);
      }

      const ts = payload.entryTimestamp;
      if (ts && (!state.memberEntryLastSeenAt || ts > state.memberEntryLastSeenAt)) {
        state.memberEntryLastSeenAt = ts;
        persistLastSeen(ts);
      }
    },
    dismissCurrentMemberEntry(state) {
      state.memberEntryQueue.shift();
    },
    retainWatchedMemberEntries(state, branchIds) {
      state.memberEntryQueue = state.memberEntryQueue
        .filter((entry) => isWatchedEntry(entry, branchIds));
    },
    resetMemberEntryHubState(state) {
      state.memberEntryQueue = [];
      state.memberEntrySeenIds = [];
      state.memberEntryLastSeenAt = null;
      persistLastSeen(null);
    },
  },
};
